
import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({})
export default class CouponContent extends Vue {
  @Prop({ default: () => ({}) })
  couponData: any;
}
